"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4445],{

/***/ 96491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Gallery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68779);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73582);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67814);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55791);





// import Swiper core and required modules




// Import Swiper styles

// install Swiper modules
swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Lazy */ .oM
]);




function Gallery(props) {
    var localizePath = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useLocalizePath */ .Wb)();
    var myLoader = function(param) {
        var src = param.src;
        return "".concat(src, "?q=55");
    };
    var navigation = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidArrayKeysNotNull */ .Z.isValidArrayKeysNotNull(props.images) && props.images.length > 1 ? {
        nextEl: ".swiper-custom-next",
        prevEl: ".swiper-custom-prev"
    } : false;
    var validGallery = false;
    validGallery = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidArray */ .Z.isValidArray(props.images) ? props.images.map(function(slide) {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidString */ .Z.isValidString(slide)) return true;
    }) : false;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: props.galleryRef,
        className: "Properties__gallery ".concat(!props.isHotel ? "properties" : ""),
        onClick: !validGallery && props.images.length != 0 ? function() {
            return window.open(localizePath("/property/" + props.property_id), "_blank");
        } : undefined,
        style: {
            height: (props === null || props === void 0 ? void 0 : props.galleryHeight) ? props.galleryHeight : 285
        },
        children: validGallery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
            height: 300,
            speed: 1000,
            navigation: navigation,
            noSwiping: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidBoolean */ .Z.isValidBoolean(navigation),
            pagination: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                dynamicBullets: true,
                dynamicMainBullets: 3
            }, props.isHotel && {
                el: ".custom-pagination"
            }),
            style: {
                borderRadius: "0px"
            },
            slidesPerView: 1,
            children: [
                _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].objChildExists */ .Z.objChildExists(props, "borderBottom") && !props.borderBottom && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "swiper-button-close swiper-button-custom-close",
                    onMouseDown: function() {
                        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].objChildExists */ .Z.objChildExists(props, "setInfoWindowState") ? props.setInfoWindowState(null) : undefined;
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faClose */ .YIN,
                        className: "text-white opacity-75 fs-16"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "swiper-button-prev swiper-custom-prev " + "".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidBoolean */ .Z.isValidBoolean(navigation) ? "hidden" : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faAngleLeft */ .EyR,
                        className: "text-master fs-16"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "swiper-button-next swiper-custom-next " + "".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidBoolean */ .Z.isValidBoolean(navigation) ? "hidden" : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faAngleRight */ .yOZ,
                        className: "text-master fs-16"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "swiper-pagination custom-pagination ".concat(props.isHotel ? "inline-pagination" : "")
                }),
                props.images.map(function(slide, key) {
                    var ref;
                    return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidString */ .Z.isValidString(slide) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                loader: myLoader,
                                priority: key == 0,
                                layout: "fill",
                                sizes: "55vw",
                                quality: "55",
                                src: slide,
                                alt: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isValidString */ .Z.isValidString(props.altTitle) ? key === 0 ? props.altTitle : "".concat(props.altTitle, " - ").concat(key + 1) : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"].removeEmojis */ .Z.removeEmojis((ref = props.captions) === null || ref === void 0 ? void 0 : ref[key]) || "Property Slide-".concat(props.property_id, "-").concat(key),
                                objectFit: "cover",
                                placeholder: "blur",
                                blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bg-overlay z-index-1 position-absolute start-0",
                                style: {
                                    background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.0) , rgba(0, 0, 0, 0.3))",
                                    height: "35%",
                                    top: "unset",
                                    bottom: "15%"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bg-overlay z-index-1 position-absolute start-0",
                                style: {
                                    background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.3) , rgba(0, 0, 0, 0.8))",
                                    height: "15%",
                                    top: "unset",
                                    bottom: 0
                                }
                            })
                        ]
                    }, key);
                })
            ]
        }, "gallery-swiper-inner-" + props.property_id)
    }, "gallery-swiper-" + props.property_id);
}


/***/ }),

/***/ 79075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PanelBody; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(72462);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(55791);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(28695);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./helpers/HandlerHelper.tsx
var HandlerHelper = __webpack_require__(7836);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(23077);
// EXTERNAL MODULE: ./helpers/LgConsts.tsx
var LgConsts = __webpack_require__(34116);
;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/BookingBedroomButtons.tsx








function BookingBedroomButtons(props) {
    var t = (0,i18n/* useT */.NT)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var showIquires = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_bookings_inquires_allow");
    });
    var propertyInitialAvailability = (0,es/* useSelector */.v9)(function(state) {
        return state["propertyAvailability"]["initialAvailability"];
    });
    var inquiriesOnly = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["inquiriesOnly"];
    });
    var bedroomPricing = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bedroomPricing"];
    });
    var priceLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["priceLoading"];
    });
    var adults = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["kids"];
    });
    var infants = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["infants"];
    });
    var dateRangeValid = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["dateRangeValid"];
    });
    var personsForBooking = adults + kids + infants;
    var inquiryUrl = (0,HandlerHelper/* generateIquiryUrlHandler */.qZ)();
    var bookUrl = (0,HandlerHelper/* generateBookUrlHandler */.JM)();
    var enableButtons = (0,MethodHelper/* enableBookingBtn */.AE)(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid);
    var bookingType = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bookingType"];
    });
    var builder_booking_box_class = "col-12 col-sm-8 col-md-6 col-lg-12 ms-auto me-auto ms-lg-0 me-lg-0";
    var builder_booking_box_border = false;
    var builder_booking_box_shadow = false;
    var builder_booking_box_radius = 0;
    var hasPrice = props.price;
    var white_class = "bg-master-lightest";
    if (!builder_booking_box_border && !builder_booking_box_shadow && builder_booking_box_radius === 0) {
        white_class = "bg-white";
    }
    var modifyRoomParam = function(url, newRoomValue) {
        var urlObj = new URL(url);
        urlObj.searchParams.set("room", newRoomValue);
        return urlObj.toString();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: builder_booking_box_class,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row",
            children: inquiriesOnly != "1" && Checkers/* default.isValidString */.Z.isValidString(bookUrl) && (bookingType == LgConsts/* default.BOOKING_TYPE_2_WEBHOTELIER */.Z.BOOKING_TYPE_2_WEBHOTELIER || propertyInitialAvailability && bookingType == LgConsts/* default.BOOKING_TYPE_1_INQUIRIES */.Z.BOOKING_TYPE_1_INQUIRIES) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    dispatch((0,actions/* updateBookingFormTriggered */.Vz)(true));
                },
                className: "col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "btn btn-lg btn-default btn-black full-width btn-bordered " + (hasPrice ? "" : "disabled"),
                    target: "_blank",
                    rel: "noreferrer",
                    href: modifyRoomParam(bookUrl, "".concat(props.whRoomCode)),
                    children: t("booking.bookNow")
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/property/content/columned/left/BookingInquireChainButtons.tsx









function BookingInquireChainButtons(props) {
    var t = (0,i18n/* useT */.NT)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var showIquires = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_bookings_inquires_allow");
    });
    var inquiriesActiveForSingleBedroom = props.inquiriesActiveForSingleBedroom, hasOpenCalendar = props.hasOpenCalendar, isAvailable = props.isAvailable;
    var propertyInitialAvailability = (0,es/* useSelector */.v9)(function(state) {
        return state["propertyAvailability"]["initialAvailability"];
    });
    var inquiriesOnly = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["inquiriesOnly"];
    });
    var bedroomPricing = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bedroomPricing"];
    });
    var priceLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["priceLoading"];
    });
    var adults = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["kids"];
    });
    var infants = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["infants"];
    });
    var dateRangeValid = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["dateRangeValid"];
    });
    var personsForBooking = adults + kids + infants;
    var inquiryUrl = (0,HandlerHelper/* generateIquiryUrlHandler */.qZ)();
    var bookUrl = (0,HandlerHelper/* generateBookUrlHandler */.JM)();
    var enableButtons = (0,MethodHelper/* enableBookingBtn */.AE)(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid);
    var bookingType = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bookingType"];
    });
    var ref = (0,react.useState)(false), canInquire = ref[0], setCanInquire = ref[1];
    var ref1 = (0,react.useState)(false), infoNeeded = ref1[0], setInfoNeeded = ref1[1];
    var isSuccess = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["success"];
    });
    var builder_booking_box_class = "col-12 col-sm-8 col-md-6 col-lg-12 ms-auto me-auto ms-lg-0 me-lg-0";
    var builder_booking_box_border = false;
    var builder_booking_box_shadow = false;
    var builder_booking_box_radius = 0;
    var ref2 = (0,react.useState)(false), showToast = ref2[0], setShowToast = ref2[1];
    var hasPrice = props.price;
    var white_class = "bg-master-lightest";
    if (!builder_booking_box_border && !builder_booking_box_shadow && builder_booking_box_radius === 0) {
        white_class = "bg-white";
    }
    var modifyRoomParam = function(url, newRoomValue) {
        var urlObj = new URL(url);
        urlObj.searchParams.set("room", newRoomValue);
        return urlObj.toString();
    };
    (0,react.useEffect)(function() {
        if (isSuccess) {
            setCanInquire(true);
        }
    }, [
        isSuccess,
        canInquire
    ]);
    var emptyEntriesHandler = function() {
        if (isSuccess) {
            setInfoNeeded(true);
        } else {
            setInfoNeeded(false);
        }
        setShowToast(true);
        var el = document.getElementById("booking-search-bar");
        dispatch((0,actions/* setSearchbarEmptyFields */.Gr)(true));
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
        setTimeout(function() {
            setShowToast(false);
        }, 5000);
    };
    var isDisabled = !canInquire || isAvailable == 0;
    var isDisabledForInquiry = (!canInquire || isAvailable == 0) && !hasOpenCalendar;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: builder_booking_box_class,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    inquiriesOnly == "1" || showIquires == "1" || bookingType == LgConsts/* default.BOOKING_TYPE_1_INQUIRIES */.Z.BOOKING_TYPE_1_INQUIRIES ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        onClick: function(e) {
                            if (isDisabled) {
                                e.preventDefault();
                                emptyEntriesHandler();
                                return;
                            }
                            dispatch((0,actions/* updateBookingFormTriggered */.Vz)(true));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "btn btn-lg btn-default btn-black full-width btn-bordered ".concat(isDisabledForInquiry ? "disabled" : ""),
                            target: "_blank",
                            rel: "noreferrer",
                            href: inquiryUrl,
                            children: t("booking.inquire")
                        })
                    }) : "",
                    !inquiriesActiveForSingleBedroom && inquiriesOnly != "1" && Checkers/* default.isValidString */.Z.isValidString(bookUrl) && (bookingType == LgConsts/* default.BOOKING_TYPE_2_WEBHOTELIER */.Z.BOOKING_TYPE_2_WEBHOTELIER || propertyInitialAvailability && bookingType == LgConsts/* default.BOOKING_TYPE_1_INQUIRIES */.Z.BOOKING_TYPE_1_INQUIRIES) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        onClick: function(e) {
                            if (isDisabled) {
                                e.preventDefault();
                                emptyEntriesHandler();
                                return;
                            }
                            dispatch((0,actions/* updateBookingFormTriggered */.Vz)(true));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "btn btn-lg btn-primary btn-design-color full-width " + (!isDisabled ? "" : "disabled"),
                            target: "_blank",
                            rel: "noreferrer",
                            href: modifyRoomParam(bookUrl, "".concat(props.whRoomCode)),
                            children: t("booking.bookNow")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            showToast && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "toast-container position-fixed bottom-0 start-0 p-3",
                style: {
                    zIndex: 999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "toast show align-items-center text-bg-danger border-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "toast-body",
                                children: infoNeeded ? t("booking.noAvailabilityRange") : t("booking.selectDatesAndGuests")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "btn-close btn-close-white me-2 m-auto",
                                onClick: function() {
                                    return setShowToast(false);
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/templates/properties/panel/PanelBody.tsx











function PanelBody(props) {
    var t = (0,i18n/* useT */.NT)();
    var isEstate = props.hasOwnProperty("isEstate") ? props.isEstate : false;
    var minmimStayData = props.hasOwnProperty("minmimStayData") ? props.minmimStayData : null;
    var system_type_id = props.hasOwnProperty("system_type_id") ? props.system_type_id : null;
    var classification = props.hasOwnProperty("classification") ? props.classification : null;
    var hidePriceForSingleBedroom = props.hasOwnProperty("hidePrices") ? props.hidePrices : null;
    var inquiriesActiveForSingleBedroom = props.hasOwnProperty("inquiriesActive") ? props.inquiriesActive : null;
    var hasOpenCalendar = props.hasOpenCalendar, _isNotForList = props.isNotForList, isNotForList = _isNotForList === void 0 ? false : _isNotForList;
    var propertyType = props.hasOwnProperty("propertyType") ? props.propertyType : null;
    var isHotel = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHotel"];
    });
    var isChain = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isChain"];
    });
    var ref;
    var labelForPropertiesWithoutPrices = (ref = (0,MethodHelper/* customBuilderLabel */.es)((0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_inquires_label");
    }), MethodHelper/* UPON_REQUEST_DEFAULT_LABELS */.Gw)) !== null && ref !== void 0 ? ref : t("property.uponRequest");
    var hidePrices = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertylist_hide_prices") == 1;
    });
    var showMinimumStayNotice = minmimStayData != undefined && minmimStayData.hasOwnProperty("minimumStayInvalid") ? minmimStayData.minimumStayInvalid : false;
    var extraDaysForMinimumStay = minmimStayData != null && minmimStayData.hasOwnProperty("extraDaysForMinimumStay") ? minmimStayData.extraDaysForMinimumStay : null;
    var minimumStay = minmimStayData != null && minmimStayData.hasOwnProperty("minimumStay") ? minmimStayData.minimumStay : null;
    var paragraphClassName = showMinimumStayNotice || !(props.minimumPrice && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.minimumPrice)) ? "m-t-5" : "m-t-15";
    var paragraphMinStayClassName = showMinimumStayNotice ? "m-t-0" : "m-t-20";
    var spanColorClassname = showMinimumStayNotice ? "text-danger" : "text-master";
    var dispatch = (0,es/* useDispatch */.I0)();
    var propertyPrice = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* getPropertyPricingData */.kw)(props.property_id, state["appSettings"]["propertiesPricing"], isChain ? 1 : (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_properties_webhotelier_prices"));
    });
    var bedroomPrice = props.bedroom_prices && props.bedroom_prices.find(function(price) {
        return price.bedroomId == props.property_id;
    });
    var propertiesPricingLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["propertiesPricingLoading"];
    });
    var bedroomPricingLoading = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["bedroomPricingLoading"];
    });
    var showPricingLoadingHalndler = function() {
        if (isEstate) {
            return false;
        }
        if (props.isHotel) {
            return bedroomPricingLoading;
        }
        return propertiesPricingLoading;
    };
    var extraNightsTextHandler = function() {
        if (showMinimumStayNotice) {
            if (extraDaysForMinimumStay > 1) {
                return t.plural("property.addNights", extraDaysForMinimumStay);
            } else {
                return t.plural("property.addNights", extraDaysForMinimumStay);
            }
        }
        return "";
    };
    var minimumStayTextHandler = function() {
        if (showMinimumStayNotice) {
            return t("property.minimumStayNotice", {
                count: minimumStay
            });
        }
        return "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Properties__body ".concat(props === null || props === void 0 ? void 0 : props.panelBodyClass),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(props.bodyHrefClass ? props === null || props === void 0 ? void 0 : props.bodyHrefClass : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fw-bold text-uppercaseletter-sp-normal text-color-initial fs-12 m-0",
                                children: props.property_location
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "fw-bold text-color-initial m-0 cursor-pointer",
                                onClick: props.handleShow,
                                children: props.property_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fw-normal text-color-initial fs-16 m-0 line-clamp-1",
                                children: props.property_moto !== "null" ? props.property_moto : t("property.noMotto")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "hint-text m-b-10 text-master fs-14 " + paragraphClassName,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: !isEstate && system_type_id == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.capacity) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            props.capacity,
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faUser */.ILF,
                                                className: "m-r-5"
                                            }),
                                            " ",
                                            t.plural("property.guestsLabel", Number(props.capacity))
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: system_type_id == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: Checkers/* default.isValidString */.Z.isValidString(classification) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faHotel */.Ht4,
                                                    className: "m-r-5"
                                                }),
                                                propertyType,
                                                "\xa0\xb7\xa0"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    })
                                })
                            }),
                            system_type_id !== 2 && props.isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    props.bedrooms,
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faUser */.ILF,
                                        className: "m-r-5"
                                    }),
                                    " ",
                                    t.plural("property.guestsLabel", Number(props.bedrooms))
                                ]
                            }) : system_type_id !== 2 && !props.isHotel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.bedrooms) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "\xa0\xb7\xa0",
                                        props.bedrooms,
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faBed */.by_,
                                            className: "m-r-5"
                                        }),
                                        t.plural("property.bedsLabel", Number(props.bedrooms))
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: Checkers/* default.isValidString */.Z.isValidString(classification) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faStar */.Tab,
                                            className: "m-r-5"
                                        }),
                                        classification
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: isEstate && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.bathrooms) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "\xa0\xb7\xa0",
                                            props.bathrooms,
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faShower */.ljI,
                                                className: "m-r-5"
                                            }),
                                            " (",
                                            t("property.bathroomsLabel"),
                                            ")"
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.complexCount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        props.complexCount,
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faBuildings */.gju,
                                            className: "m-r-5"
                                        }),
                                        " ",
                                        t("property.groupLabel")
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            })
                        ]
                    }),
                    showPricingLoadingHalndler() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-right m-t-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "fs-16 text-master",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_regular_svg_icons/* faSpinner */.LM3,
                                    spin: true
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !hidePrices && !isEstate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    !props.isHotel && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: props.availabilityStatus != undefined && props.availabilityStatus == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-right m-t-20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-16 text-master",
                                                    children: t("property.notAvailableDates")
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: props.minimumPrice && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(props.minimumPrice) && !hidePriceForSingleBedroom && (!isNotForList || propertyPrice && propertyPrice.isAvailable) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-right " + paragraphMinStayClassName,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: propertyPrice != null && propertyPrice.dayOriginalPrice != propertyPrice.dayPrice && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(propertyPrice.dayOriginalPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "fs-16 " + spanColorClassname,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "hint-text fs-16",
                                                                        style: {
                                                                            textDecoration: "line-through"
                                                                        },
                                                                        children: [
                                                                            "€",
                                                                            propertyPrice.formattedDayOriginalPrice
                                                                        ]
                                                                    }),
                                                                    "\xa0"
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "fs-16 " + spanColorClassname,
                                                        children: [
                                                            extraNightsTextHandler(),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: propertyPrice == null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        t("property.from"),
                                                                        "\xa0"
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "bold",
                                                                children: [
                                                                    "€",
                                                                    propertyPrice == null ? parseFloat(props.minimumPrice).toFixed(0) : propertyPrice.formattedDayPrice
                                                                ]
                                                            }),
                                                            t("property.perNight")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: propertyPrice != null && !hidePriceForSingleBedroom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "fs-16 " + spanColorClassname,
                                                                children: [
                                                                    "\xa0|\xa0",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "hint-text fs-14",
                                                                        children: [
                                                                            "€",
                                                                            propertyPrice.formattedPrice,
                                                                            "\xa0",
                                                                            t("property.total")
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "fs-12 text-danger block",
                                                        children: minimumStayTextHandler()
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-right m-t-5",
                                                children: [
                                                    !hidePriceForSingleBedroom && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "fs-16 text-master",
                                                        children: labelForPropertiesWithoutPrices
                                                    }),
                                                    !hidePriceForSingleBedroom && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "fs-12 text-master block",
                                                        children: t("property.mayInquire")
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    props.isHotel && !props.hideBookingActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: props.availabilityStatus != undefined && props.availabilityStatus == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-right m-t-20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-16 text-master",
                                                    children: t("property.notAvailableDates")
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: bedroomPrice && bedroomPrice.price !== 0 ? // props.minimumPrice && Checkers.isValidPositiveNumber(props.minimumPrice) ?
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-right " + paragraphMinStayClassName,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: // (bedroomPrice != null && bedroomPrice.dayOriginalPrice != bedroomPrice.dayPrice && Checkers.isValidPositiveNumber(bedroomPrice.dayOriginalPrice)) ?
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "fs-16 " + spanColorClassname,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "hint-text fs-16",
                                                                        style: {
                                                                            textDecoration: "line-through"
                                                                        },
                                                                        children: [
                                                                            "€",
                                                                            bedroomPrice && bedroomPrice.formattedDayOriginalPrice
                                                                        ]
                                                                    }),
                                                                    "\xa0"
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "fs-16 " + spanColorClassname,
                                                        children: [
                                                            extraNightsTextHandler(),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: bedroomPrice == null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        t("property.from"),
                                                                        "\xa0"
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "bold",
                                                                children: [
                                                                    "€",
                                                                    bedroomPrice == null ? parseFloat(props.minimumPrice).toFixed(0) : bedroomPrice.formattedDayPrice
                                                                ]
                                                            }),
                                                            t("property.perNight")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: bedroomPrice != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "fs-16 " + spanColorClassname,
                                                                children: [
                                                                    "\xa0|\xa0",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "hint-text fs-14",
                                                                        children: [
                                                                            "€",
                                                                            bedroomPrice.formattedPrice,
                                                                            "\xa0",
                                                                            t("property.total")
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "fs-12 text-danger block",
                                                        children: minimumStayTextHandler()
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-right " + paragraphMinStayClassName,
                                                children: t("property.notAvailable")
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: !hidePrices ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: props.estatePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-right m-t-20",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "fs-16 text-master",
                                                children: [
                                                    "€ ",
                                                    props.estatePrice
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-right m-t-20",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "fs-16 text-master",
                                                children: t("property.uponRequest")
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            }),
                            props.isHotel && !props.hideBookingActions && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingBedroomButtons, {
                                price: bedroomPrice && bedroomPrice.price,
                                whRoomCode: bedroomPrice && bedroomPrice.whRoomCode
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function(e) {
                                    return !propertyPrice && !hasOpenCalendar ? e.preventDefault() : null;
                                },
                                style: {
                                    cursor: propertyPrice && propertyPrice.isAvailable ? "pointer" : "default"
                                },
                                children: props.isChain && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInquireChainButtons, {
                                    price: propertyPrice && propertyPrice.price,
                                    whRoomCode: propertyPrice && propertyPrice.whRoomCode,
                                    inquiriesActiveForSingleBedroom: inquiriesActiveForSingleBedroom,
                                    hasOpenCalendar: hasOpenCalendar,
                                    isAvailable: propertyPrice && propertyPrice.isAvailable
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 7836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JM": function() { return /* binding */ generateBookUrlHandler; },
/* harmony export */   "SH": function() { return /* binding */ priceHandler; },
/* harmony export */   "qZ": function() { return /* binding */ generateIquiryUrlHandler; }
/* harmony export */ });
/* harmony import */ var _class_Checkers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55791);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23077);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);



var priceHandler = function(dispatch) {
    var forList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, page_id = arguments.length > 2 ? arguments[2] : void 0, property_id = arguments.length > 3 ? arguments[3] : void 0, priceInitialized = arguments.length > 4 ? arguments[4] : void 0, checkin = arguments.length > 5 ? arguments[5] : void 0, checkout = arguments.length > 6 ? arguments[6] : void 0, priceNeedUpdate = arguments.length > 7 ? arguments[7] : void 0, adults = arguments.length > 8 ? arguments[8] : void 0, kids = arguments.length > 9 ? arguments[9] : void 0;
    if (forList) {
        return;
    }
    // const checkin = useSelector(state => state['propertiesParams']['checkin'])
    // const checkout = useSelector(state => state['propertiesParams']['checkout'])
    // const adults = useSelector(state => state['propertiesParams']['adults'])
    // const kids = useSelector(state => state['propertiesParams']['kids'])
    // const infants = useSelector(state => state['propertiesParams']['infants'])
    // const price = useSelector(state => state['appSettings']['price'])
    // const finalPrice = useSelector(state => state['appSettings']['finalPrice'])
    // const discount = useSelector(state => state['appSettings']['discount'])
    // const hasDiscount = useSelector(state => state['appSettings']['hasDiscount'])
    // const accommondationLength = useSelector(state => state['appSettings']['accommondationLength'])
    // const securityDeposit = useSelector(state => state['appSettings']['securityDeposit'])
    // const dateRangeValid = useSelector(state => state['propertiesParams']['dateRangeValid'])
    // const page_id = useSelector(state => state['propertiesParams']['page_id'])
    // const property_id = useSelector(state => state['propertiesParams']['property_id'])
    //
    // const priceInitialized = useSelector(state => state['appSettings']['priceLoading'])
    if (priceNeedUpdate && _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidDate */ .Z.isValidDate(checkin) && _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidDate */ .Z.isValidDate(checkout)) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .fetchPropertyPrice */ .e2)(property_id, page_id, checkin, checkout, adults, kids));
    }
// return [price, finalPrice, discount, hasDiscount, accommondationLength, securityDeposit]
};
var generateIquiryUrlHandler = function() {
    var bookingAppUrl = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["bookingAppUrl"];
    });
    var checkin = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var adults = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["kids"];
    });
    var infants = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["infants"];
    });
    var bedroomId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["bookingBedroomId"];
    });
    var propertySlug = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["propertySlug"];
    });
    var params = {
        bedroom: bedroomId,
        kids: 0
    };
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidDate */ .Z.isValidDate(checkin)) {
        params["from"] = checkin;
    }
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidDate */ .Z.isValidDate(checkout)) {
        params["to"] = checkout;
    }
    if (adults > 0) {
        params["guests"] = adults;
    }
    if (kids > 0) {
        params["kids"] += kids;
    }
    if (infants > 0) {
        params["kids"] += infants;
    }
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(propertySlug)) {
        // @ts-ignore
        return bookingAppUrl + "/en/inquiry-form/" + propertySlug + "?" + new URLSearchParams(params).toString();
    }
    // @ts-ignore
    return bookingAppUrl + "/en/book?" + new URLSearchParams(params).toString();
};
var generateBookUrlHandler = function() {
    var bookUrl = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["bookUrl"];
    });
    var roomCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["roomCode"];
    });
    var checkin = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var adults = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["kids"];
    });
    var infants = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["infants"];
    });
    var wh_direct_checkout = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["whDirectCheckout"];
    });
    if (!_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(bookUrl)) {
        return null;
    }
    var url = bookUrl;
    var params = {
        room: roomCode
    };
    params["exclusive"] = 1;
    if (wh_direct_checkout) {
        params["direct"] = 1;
    }
    params["adults"] = 0;
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidDate */ .Z.isValidDate(checkin)) {
        params["checkin"] = checkin;
    }
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidDate */ .Z.isValidDate(checkout)) {
        params["checkout"] = checkout;
    }
    if (adults >= 0) {
        params["adults"] = adults;
    }
    if (kids >= 0) {
        params["children"] = kids;
    }
    if (infants >= 0) {
        params["infants"] = infants;
    }
    return url + (url.includes("?") ? "&" : "?") + new URLSearchParams(params).toString();
};


/***/ })

}]);